// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1lmue","requiredAsterisk":"Info_requiredAsterisk__2RMHO"};